<section class="pb-0" id="iq-about">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 text-center">
                <div class="d-flex flex-column align-items-center">
                    <div class="title-box mb-4 text-center">
                        <h3 class="mb-3">Alcanzá puestos extraordinarios</h3>
                        <p>Especialización altamente específica.<br>Puestos laborales de alta demanda.</p>
                    </div>
                    <!-- <a class="button gradient-btn button-icon mb-4" href="#"><span class="btn-effect">Empezar</span></a> -->
                    <img src="./assets/sofbox-v2/images/home-3/1.svg" alt="img">
                </div>
            </div>
        
            <div class="col-lg-6 text-center">
                <div class="d-flex flex-column align-items-center">
                    <div class="title-box mb-4 text-center">
                        <h3 class="mb-3">Apostá por una mejor posición laboral</h3>
                        <p>Estudia mientras seguís trabajando.<br>Un Upgrade de puesto laboral.</p>
                    </div>
                    <!-- <a class="button gradient-btn button-icon mb-4" href="#"><span class="btn-effect">Empezar</span></a> -->
                    <img src="./assets/sofbox-v2/images/home-3/2.svg" alt="img">
                </div>
            </div>
        </div>
        
    </div>
</section>